import { render, staticRenderFns } from "./HtmlFieldtype.vue?vue&type=template&id=5c25c808&"
import script from "./HtmlFieldtype.vue?vue&type=script&lang=js&"
export * from "./HtmlFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports